/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetExportActivitiesQueryResponse,
  GetExportActivitiesQueryParams,
} from '../models/GetExportActivities.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getExportActivitiesQueryResponseSchema } from '../zod/getExportActivitiesSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getExportActivitiesQueryKey = (
  params: GetExportActivitiesQueryParams,
) => [{ url: '/api/export/activities' }, ...(params ? [params] : [])] as const;

export type GetExportActivitiesQueryKey = ReturnType<
  typeof getExportActivitiesQueryKey
>;

/**
 * {@link /api/export/activities}
 */
export async function getExportActivities(
  params: GetExportActivitiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetExportActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/export/activities`,
    params,
    ...requestConfig,
  });
  return getExportActivitiesQueryResponseSchema.parse(res.data);
}

export function getExportActivitiesQueryOptions(
  params: GetExportActivitiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getExportActivitiesQueryKey(params);
  return queryOptions<
    GetExportActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    GetExportActivitiesQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getExportActivities(params, config);
    },
  });
}

/**
 * {@link /api/export/activities}
 */
export function useGetExportActivities<
  TData = GetExportActivitiesQueryResponse,
  TQueryData = GetExportActivitiesQueryResponse,
  TQueryKey extends QueryKey = GetExportActivitiesQueryKey,
>(
  params: GetExportActivitiesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetExportActivitiesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getExportActivitiesQueryKey(params);

  const query = useQuery(
    {
      ...getExportActivitiesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
